import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GenericDropDownV3 } from '@nu-art/thunderstorm-frontend/index';
import { ModuleFE_Pathway, ModuleFE_PathwayState, ModuleFE_PathwayTransition } from '../../_entity.js';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { DropDown_Action } from '../../_entity/action/ui-components.js';
const Props_Pathway = {
    module: ModuleFE_Pathway,
    modules: [ModuleFE_Pathway],
    mapper: item => [item.label],
    placeholder: 'Choose a pathway',
    renderer: item => _jsx("div", { className: 'node-data', children: item.label }),
};
const Props_PathwayState = {
    module: ModuleFE_PathwayState,
    modules: [ModuleFE_PathwayState],
    mapper: item => [item.name],
    placeholder: 'Choose a state',
    renderer: item => _jsx("div", { className: 'node-data', children: item.name }),
};
const Props_PathwayTransition = {
    module: ModuleFE_PathwayTransition,
    modules: [ModuleFE_PathwayTransition],
    placeholder: 'Choose a transition',
    mapper: item => {
        const origin = ModuleFE_PathwayState.cache.unique(item.sourceId);
        const target = ModuleFE_PathwayState.cache.unique(item.targetId);
        if (!origin)
            throw new MUSTNeverHappenException(`Could not find an origin state for id ${item.sourceId}`);
        if (!target)
            throw new MUSTNeverHappenException(`Could not find an target state for id ${item.targetId}`);
        return [origin.name, target.name];
    },
    renderer: item => {
        const origin = ModuleFE_PathwayState.cache.unique(item.sourceId);
        const target = ModuleFE_PathwayState.cache.unique(item.targetId);
        if (!origin)
            throw new MUSTNeverHappenException(`Could not find an origin state for id ${item.sourceId}`);
        if (!target)
            throw new MUSTNeverHappenException(`Could not find an target state for id ${item.targetId}`);
        return _jsxs("div", { className: 'node-data', children: [origin.name, " ", '=>', " ", target.name] });
    }
};
export const PathwayDropdowns = {
    Action: DropDown_Action.selectable,
    Pathway: GenericDropDownV3.prepareSelectable(Props_Pathway),
    PathwayState: GenericDropDownV3.prepareSelectable(Props_PathwayState),
    PathwayTransition: GenericDropDownV3.prepareSelectable(Props_PathwayTransition),
};
//# sourceMappingURL=app-dropdowns.js.map